import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Selectors } from "../../../Everou/_reducers/app.reducer";
import { IntegrationAccountDraft, IntegrationCompany } from "../../../Everou/_modelsTS/Integration";

// The account draft (PMSAccountDraftStore) meant for `company`'s panel, or
// null: a draft left for another company is not this panel's business.
//
// Memoized on the store's object: the panels rebuild their rows in an effect
// keyed on this value, so a fresh object per render would loop them forever.
export function useAccountDraft(company: IntegrationCompany): IntegrationAccountDraft | null {
    const draft = useSelector(Selectors.getPMSAccountDraft) as
        ({ company: IntegrationCompany } & IntegrationAccountDraft) | null;
    return useMemo(() => {
        if (!draft || draft.company !== company) return null;
        const { company: _company, ...credentials } = draft;
        return credentials;
    }, [draft, company]);
}
